import { AxiosResponse } from 'axios';

export const common = 'エラーが発生しました。';
export const browserBack = '前のページには戻れません。';

export interface ErrorResponseType extends AxiosResponse {
  data: {
    message: string;
    errors: string;
  };
}
